<template>
    <div class="searchTabWrapper">
        <div class="tabLabel">{{ attrs.label }}：</div>
        <div>
            <div class="searchTabList">
                <div
                    class="searchTabItem"
                    :class="[checkedIdList.length === 0 ? 'active' : '']"
                    @click="handleAllClick"
                >
                    全部
                </div>
                <div
                    v-for="item in items"
                    :key="item.value"
                    :class="[checkedIdList.includes(item.value)  ? 'active' : '']"
                    @click="handleItemClick(item)"
                    class="searchTabItem"
                >
                  {{ item.label }}
                </div>
            </div>
            <div
                class="secondList"
                v-if="childItem.length"
            >
                <div
                    v-for="item in childItem"
                    :key="item.value"
                    :class="[childIdList.includes(item.value) ? 'active' : '']"
                    @click="handleChildClick(item)"
                    class="searchTabItem"
                >
                    {{ item.label }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    watch: {
        value (newVal) {
            this.checkedItem = [];
            this.checkedIdList = [];
            this.childItem = [];
            if (Array.isArray(newVal)) {
                this.items.forEach((item) => {
                    if (newVal.includes(item.value)) {
                        this.checkedItem.push(item);
                        this.checkedIdList.push(item.value);
                        if(item.children && item.children.length){
                            this.childItem = this.childItem.concat(item.children)
                        }
                    }
                });
                this.childIdList = newVal;
            } else {
                this.childIdList = [];
                this.items.forEach(item => {
                    if(item.value == newVal){
                        this.checkedItem.push(item)
                        this.checkedIdList.push(item.value);
                        if(item.children && item.children.length){
                            this.childItem = this.childItem.concat(item.children)
                        }
                    }
                })
            }
        },
    },
    props: {
        value: [Array, Number, String],
        attrs: {
            type: Object,
            default() {
                return {};
            },
        },
        items: {
            type: Array, 
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            checkedItem: [],
            checkedIdList:[],
            childItem: [],
            childIdList: [],
        };
    },
    methods: {
        handleItemClick (item) {
            const nextValue = [...this.value];
            const index = nextValue.findIndex((i) => i == item.value);
            if (index > -1) {
                nextValue.splice(index, 1);
            } else {
                nextValue.push(item.value);
            }
            this.changeVal(nextValue);
        },
        handleAllClick() {
            this.changeVal([]);
        },
        handleChildClick(item) {
            const nextValue = [...this.value];
            const index = nextValue.findIndex((i) => i == item.value);
            if (index > -1) {
                nextValue.splice(index, 1);
            } else {
                nextValue.push(item.value);
            }
            this.changeVal(nextValue);
        },
        changeVal(valArr) {
            this.$emit("input", [...new Set(valArr)]);
        },
    },
};
</script>

<style lang="scss" scoped>
.searchTabWrapper {
    display: flex;
    margin-bottom: 7px;
}
.tabLabel {
    word-break: keep-all;
    line-height: 26px;
}
.searchTabList {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.searchTabItem {
    display: inline-block;
    border: 1px solid transparent;
    box-sizing: border-box;
    background: #ffffff;
    padding: 0 12px;
    border-radius: 2px;
    line-height: 26px;
    font-size: 12px;
    word-break: keep-all;
    margin-left: 4px;
    cursor: pointer;
    margin-bottom: 2px;
    color: #3c3c3c;
    &.active {
        color: #2695fa;
        border: 1px solid #2695fa;
        position: relative;
        background: #fff;

        &:before {
            display: block;
            position: absolute;
            content: "";
            top: 0;
            right: 0;
            border-right: 12px solid #2695fa;
            border-bottom: 12px solid transparent;
        }
        &:after {
            content: "";
            display: block;
            position: absolute;
            top: 1px;
            right: 1px;
            border-left: 1px solid #fff;
            border-bottom: 1px solid #fff;
            height: 2px;
            width: 4px;
            transform: rotate(-45deg);
        }
    }
}
.secondList {
    border-radius: 4px;
    padding: 3px 4px;
    background: #f5f6f7;
    margin-left: 4px;
    margin-top: 8px;
    .searchTabItem {
        background: #f5f6f7;
    }
}
</style>